import { render, staticRenderFns } from "./wfsplayer.vue?vue&type=template&id=169c2554&"
import script from "./wfsplayer.vue?vue&type=script&lang=js&"
export * from "./wfsplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports